import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { ActionNames, error, fetchedReview, FetchReview, ListReview, listReviewResult, ReviewSubmit, submitDone } from '../actions';

const fetch = window.fetch.bind(window);

const host = '';
const hostPrefix = host ? `://${host}` : '';
const apiUrl = (route: string) => `${hostPrefix}/${route}`;

const post = (url: string, data: object) => fetch(url, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
});

const postForm = (url: string, form: FormData) => fetch(url, {
    method: 'POST',
    headers: {
        Accept: 'application/json'
    },
    body: form
});

const buildForm = (files: File[]) => {
    const form = new FormData();
    for (const file of files) {
        form.append(file.name, file, file.name);
    }

    return form;
};

function* fetchReview(action: FetchReview) {
    const { token } = action;
    const resp: Response = token ? yield call(fetch,  apiUrl(`api/reviews/${token}`)) : { status: 400 };

    if (resp.status < 400) {
        const review = yield call(resp.json.bind(resp));

        yield put(fetchedReview(review));
    } else {
        yield put(error('No review found'));
    }
}

function* uploadPictures(action: ReviewSubmit) {
    const { files, token } = action;

    if (!files || files.length === 0) {
        return [];
    }

    const form = buildForm(files);

    const resp = yield call(postForm, apiUrl(`api/reviews/${token}/pictures`), form);

    return yield call(resp.json.bind(resp));
}

function* submitReview(action: ReviewSubmit) {
    const { review, token } = action;
    const imageUrls = yield uploadPictures(action);
    const fullUrls = imageUrls.map(x => x.item1);
    const thumbUrls = imageUrls.map(x => x.item2);
    review.pictureUrls = [...review.pictureUrls, ...fullUrls];
    review.thumbnailUrls = [...review.pictureUrls, ...thumbUrls];

    const resp: Response = yield call(post, apiUrl(`api/reviews/${token}`), review);
    const posted = yield call(resp.json.bind(resp));
    yield put(fetchedReview(posted));
    if (action.done) {
        action.done();
    }
    yield put(submitDone);
}

function* listReviews(action: ListReview) {
    const resp = yield call(fetch, apiUrl('api/reviews'));
    const reviews = yield call(resp.json.bind(resp));

    if (action.done) {
        action.done();
    }

    yield put(listReviewResult(reviews));
}

function* handleFetch() {
    yield takeLatest(ActionNames.ReviewActions.fetch, fetchReview);
}

function* handleSubmit() {
    yield takeLatest(ActionNames.ReviewActions.submit, submitReview);
}

function* handeList() {
    yield takeLatest(ActionNames.ReviewActions.list, listReviews);
}

function* handleReviews() {
    yield all([
        fork(handleFetch),
        fork(handleSubmit),
        fork(handeList)
    ]);
}

export default handleReviews;
